module.exports = __webpack_public_path__ + "img/list.4ffb0589.svg";